// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"qV-z","inlineTitle":"rV-z","sponsoredAdsWrapper":"sV-z","marketplaceRecosWrapper":"tV-z"};